import "desvg";
import components from "@/js/components";
import pages from "@/js/pages";
import forms from "@/js/forms";

window.addEventListener("DOMContentLoaded", async () => {
    deSVG("img[inline]", true);
    components();
    pages();
    forms()
});

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
        const id = anchor.getAttribute('href');
        const target = document.querySelector(id);
        if (!target) return;

        e.preventDefault();

        const headerHeight = document.querySelector('.l-header').offsetHeight;
        const offset = target.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
            top: offset - headerHeight,
            behavior: 'smooth'
        });
    });
});
